import script from "./VolunteerPlanning.vue?vue&type=script&setup=true&lang=js"
export * from "./VolunteerPlanning.vue?vue&type=script&setup=true&lang=js"

import "./VolunteerPlanning.vue?vue&type=style&index=0&id=19aa2340&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19aa2340"]])

export default __exports__